import { useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";
import { PageHeader } from "./AdminLayout";
import { toast } from "sonner";

export default function HRMIncidents() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/hrm/incidents").then((r) => setItems(r.data)).catch(() => toast.error("Không tải được lỗi/vi phạm"));
  }, []);
  return (
    <div data-testid="page-hrm-incidents">
      <PageHeader kicker="HRM" title="Lỗi / vi phạm" breadcrumb={["HRM", "Incidents"]} />
      <div className="p-6 lg:p-8">
        <div className="bg-white border border-stone-200 rounded-sm divide-y">
          {items.map((item) => (
            <div key={item.id} className="p-3 text-sm flex items-start justify-between gap-3">
              <div>
                <div className="font-semibold">{item.employee_name || "Nhân viên"} · {item.task_name || "Công việc"}</div>
                <div className="text-stone-600">{item.description}</div>
                <div className="text-xs text-stone-500">{item.branch_name || "—"} · {fmtDateTime(item.created_at)}</div>
              </div>
              <span className="text-xs px-2 py-1 rounded-sm bg-red-100 text-red-900 font-semibold">{item.severity}</span>
            </div>
          ))}
          {items.length === 0 && <div className="p-8 text-center text-stone-400">Chưa có lỗi/vi phạm</div>}
        </div>
      </div>
    </div>
  );
}
